import { action } from "../const";

const initialState = {
    invitedUser: undefined,
    registerUser: undefined,
    device_Id: undefined,
    userInfo: undefined,
    isLogin: false,
    users: [],
    rg_video: undefined,
    isRemember: false,
    battle_rank: undefined
};

export default function authReducer(state = initialState, data) {

    switch (data.type) {
        case action.SET_REGISTER_USER:
            return Object.assign({}, state, { registerUser: data.payload })

        case action.UPDATE_AUTH_STATE:
            return Object.assign({}, state, data.payload)

        case action.SET_LOGIN_USER:
            return { ...state, userInfo: data.payload, isLogin: true }

        case action.USER_LOGOUT:
            return { ...initialState, isLogin: false }

        case action.WELCOME_VIDEO_URL:
            return { ...state, rg_video: { video: data.videoUrl, image: data.image } }

        case action.IS_REMEMBER_ME:
            return { ...state, isRemember: !state.isRemember }

        case action.VILLAGE_BATTLE_RANK:
            return { ...state, battle_rank: data.battle_rank }
        default:
            break;
    }

    return state;
}